export const doctorWhoStoryTitleLookup: {
  [season: number]: {
    [transcript: number]: string
  }
} = {
  1: {
    1: 'An Unearthly Child',
    2: 'The Daleks',
    3: 'The Edge of Destruction',
    4: 'Marco Polo',
    5: 'The Keys Of Marinus',
    6: 'The Aztecs',
    7: 'The Sensorites',
    8: 'Reign of Terror',
  },
  2: {
    1: 'Planet of Giants',
    2: 'The Dalek Invasion of Earth',
    3: 'The Rescue',
    4: 'The Romans',
    5: 'The Web Planet',
    6: 'The Crusade',
    7: 'The Space Museum',
    8: 'The Chase',
    9: 'The Time Meddler',
  },
  3: {
    0: 'Mission to the Unknown',
    1: 'Galaxy Four',
    2: 'The Myth Makers',
    3: "The Dalek's Master Plan",
    4: "The Massacre of St Bartholomew's Eve",
    5: 'The Ark',
    6: 'The Celestial Toymaker',
    7: 'The Gunfighters',
    8: 'The Savages',
    9: 'The War Machines',
  },
  4: {
    1: 'The Smugglers',
    2: 'The Tenth Planet',
    3: 'The Power of the Daleks',
    4: 'The Highlanders',
    5: 'The Underwater Menace',
    6: 'The Moonbase',
    7: 'The Macra Terror',
    8: 'The Faceless Ones',
    9: 'The Evil of the Daleks',
  },
  5: {
    1: 'The Tomb of the Cybermen',
    2: 'The Abominable Snowmen',
    3: 'The Ice Warriors',
    4: 'The Enemy of the World',
    5: 'The Web of Fear',
    6: 'Fury From The Deep',
    7: 'The Wheel In Space',
  },
  6: {
    1: 'The Dominators',
    2: 'The Mind Robber',
    3: 'The Invasion',
    4: 'The Krotons',
    5: 'The Seeds of Death',
    6: 'The Space Pirates',
    7: 'The War Games',
  },
  7: {
    1: 'Spearhead from Space',
    2: 'Doctor Who and The Silurians',
    3: 'The Ambassadors of Death',
    4: 'Inferno',
  },
  8: {
    1: 'Terror of the Autons',
    2: 'The Mind of Evil',
    3: 'The Claws of Axos',
    4: 'Colony In Space',
    5: 'The Daemons',
  },
  9: {
    1: 'Day of the Daleks',
    2: 'The Curse of Peladon',
    3: 'The Sea Devils',
    4: 'The Mutants',
    5: 'The Time Monster',
  },
  10: {
    1: 'The Three Doctors',
    2: 'Carnival of Monsters',
    3: 'Frontier in Space',
    4: 'Planet of the Daleks',
    5: 'The Green Death',
  },
  11: {
    1: 'The Time Warrior',
    2: 'Invasion of the Dinosaurs',
    3: 'Death to the Daleks',
    4: 'The Monster of Peladon',
    5: 'Planet of the Spiders',
  },
  12: {
    1: 'Robot',
    2: 'The Ark in Space',
    3: 'The Sontaran Experiment',
    4: 'Genesis of the Daleks',
    5: 'Revenge of the Cybermen',
  },
  13: {
    1: 'Terror of the Zygons',
    2: 'Planet of Evil',
    3: 'Pyramids of Mars',
    4: 'The Android Invasion',
    5: 'The Brain of Morbius',
    6: 'The Seeds of Doom',
  },
  14: {
    1: 'Masque of Mandragora',
    2: 'The Hand of Fear',
    3: 'The Deadly Assassin',
    4: 'The Face of Evil',
    5: 'The Robots of Death',
    6: 'The Talons of Weng-Chiang',
  },
  15: {
    1: 'Horror of Fang Rock',
    2: 'The Invisible Enemy',
    3: 'Image of the Fendahl',
    4: 'The Sun Makers',
    5: 'Underworld',
    6: 'The Invasion of Time',
  },
  16: {
    1: 'The Ribos Operation',
    2: 'The Pirate Planet',
    3: 'The Stones of Blood',
    4: 'The Androids of Tara',
    5: 'The Power of Kroll',
    6: 'The Armageddon Factor',
  },
  17: {
    1: 'Destiny of the Daleks',
    2: 'City of Death',
    3: 'The Creature from the Pit',
    4: 'Nightmare of Eden',
    5: 'The Horns of Nimon',
    6: 'Shada',
  },
  18: {
    1: 'The Leisure Hive',
    2: 'Meglos',
    3: 'Full Circle',
    4: 'State of Decay',
    5: "Warrior's Gate",
    6: 'The Keeper of Traken',
    7: 'Logopolis',
  },
  19: {
    1: 'Castrovalva',
    2: 'Four to Doomsday',
    3: 'Kinda',
    4: 'The Visitation',
    5: 'Black Orchid',
    6: 'Earthshock',
    7: 'Time Flight',
  },
  20: {
    1: 'Arc of Infinity',
    2: 'Snakedance',
    3: 'Mawdryn Undead',
    4: 'Terminus',
    5: 'Enlightenment',
    6: "The King's Demons",
    7: 'The Five Doctors',
  },
  21: {
    1: 'Warriors of the Deep',
    2: 'The Awakening',
    3: 'Frontios',
    4: 'Resurrection of the Daleks',
    5: 'Planet of Fire',
    6: 'The Caves of Androzani',
    7: 'The Twin Dilemma',
  },
  22: {
    1: 'Attack of the Cybermen',
    2: 'Vengeance on Varos',
    3: 'The Mark of the Rani',
    4: 'The Two Doctors',
    5: 'Timelash',
    6: 'Revelation of the Daleks',
  },
  23: {
    1: 'The Mysterious Planet',
    2: 'Mindwarp',
    3: 'Terror of the Vervoids',
    4: 'The Ultimate Foe',
  },
  24: {
    1: 'Time and the Rani',
    2: 'Paradise Towers',
    3: 'Delta and the Bannermen',
    4: 'Dragonfire',
  },
  25: {
    1: 'Remembrance of the Daleks',
    2: 'The Happiness Patrol',
    3: 'Silver Nemesis',
    4: 'The Greatest Show in the Galaxy',
  },
  26: {
    1: 'Battlefield',
    2: 'Ghost Light',
    3: 'The Curse of Fenric',
    4: 'Survival',
  },
  27: {
    0: 'The Movie',
    1: 'Rose',
    2: 'The End of the World',
    3: 'The Unquiet Dead',
    4: 'Aliens of London',
    5: 'World War Three',
    6: 'Dalek',
    7: 'The Long Game',
    8: "Father's Day",
    9: 'The Empty Child',
    10: 'The Doctor Dances',
    11: 'Boom Town',
    12: 'Bad Wolf',
    13: 'The Parting of the Ways',
  },
  28: {
    0: 'The Christmas Invasion',
    1: 'New Earth',
    2: 'Tooth and Claw',
    3: 'School Reunion',
    4: 'The Girl in the Fireplace',
    5: 'Rise of the Cybermen',
    6: 'The Age of Steel',
    7: "The Idiot's Lantern",
    8: 'The Impossible Planet',
    9: 'The Satan Pit',
    10: 'Love and Monsters',
    11: 'Fear Her',
    12: 'Army of Ghosts',
    13: 'Doomsday',
  },
  29: {
    0: 'The Runaway Bride',
    1: 'Smith and Jones',
    2: 'The Shakespeare Code',
    3: 'Gridlock',
    4: 'Daleks In Manhattan',
    5: 'Evolution Of The Daleks',
    6: 'The Lazarus Experiment',
    7: '42',
    8: 'Human Nature',
    9: 'Family of Blood',
    10: 'Blink',
    11: 'Utopia',
    12: 'The Sound of Drums',
    13: 'Last of the Time Lords',
  },
  30: {
    0: 'Voyage of the Damned',
    1: 'Partners in Crime',
    2: 'The Fires of Pompeii',
    3: 'Planet of the Ood',
    4: 'The Sontaran Stratagem',
    5: 'The Poison Sky',
    6: "The Doctor's Daughter",
    7: 'The Unicorn and The Wasp',
    8: 'Silence in the Library',
    9: 'Forest of the Dead',
    10: 'Midnight',
    11: 'Turn Left',
    12: 'The Stolen Earth',
    13: "Journey's End",
    14: 'The Next Doctor',
    15: 'Planet of the Dead',
    16: 'The Waters of Mars',
    17: 'The End of Time Part One',
    18: 'The End of Time Part Two',
  },
  31: {
    1: 'The Eleventh Hour',
    2: 'The Beast Below',
    3: 'Victory of the Daleks',
    4: 'The Time of Angels',
    5: 'Flesh and Stone',
    6: 'The Vampires of Venice',
    7: "Amy's Choice",
    8: 'The Hungry Earth',
    9: 'Cold Blood',
    10: 'Vincent and the Doctor',
    11: 'The Lodger',
    12: 'The Pandorica Opens',
    13: 'The Big Bang',
  },
  32: {
    0: 'A Christmas Carol',
    1: 'The Impossible Astronaut',
    2: 'Day of the Moon',
    3: 'Curse of the Black Spot',
    4: "The Doctor's Wife",
    5: 'The Rebel Flesh',
    6: 'The Almost People',
    7: 'A Good Man Goes To War',
    8: "Let's Kill Hitler",
    9: 'Night Terrors',
    10: 'The Girl Who Waited',
    11: 'The God Complex',
    12: 'Closing Time',
    13: 'The Wedding of River Song',
  },
  33: {
    0: 'The Doctor, the Widow, and the Wardrobe',
    1: 'Asylum of the Daleks',
    2: 'Dinosaurs on a Spaceship',
    3: 'A Town Called Mercy',
    4: 'The Power of Three',
    5: 'The Angels Take Manhattan',
    6: 'The Snowmen',
    7: 'The Bells of Saint John',
    8: 'The Rings of Akhaten',
    9: 'Cold War',
    10: 'Hide',
    11: 'Journey to the Centre of the Tardis',
    12: 'The Crimson Horror',
    13: 'Nightmare in Silver',
    14: 'The Name of the Doctor',
    15: 'The Day of the Doctor',
    16: 'The Time of the Doctor',
  },
  34: {
    1: 'Deep Breath',
    2: 'Into the Dalek',
    3: 'Robot of Sherwood',
    4: 'Listen',
    5: 'Time Heist',
    6: 'The Caretaker',
    7: 'Kill the Moon',
    8: 'Mummy on the Orient Express',
    9: 'Flatline',
    10: 'In the Forest of the Night',
    11: 'Dark Water',
    12: 'Death in Heaven',
    13: 'Last Christmas',
  },
  35: {
    1: "The Magician's Apprentice",
    2: "The Witch's Familiar",
    3: 'Under the Lake',
    4: 'Before The Flood',
    5: 'The Girl Who Died',
    6: 'The Woman Who Lived',
    7: 'The Zygon Invasion',
    8: 'The Zygon Inversion',
    9: 'Sleep No More',
    10: 'Face the Raven',
    11: 'Heaven Sent',
    12: 'Hell Bent',
    13: 'The Husbands of River Song',
  },
  36: {
    0: 'The Return of Doctor Mysterio',
    1: 'The Pilot',
    2: 'Smile',
    3: 'Thin Ice',
    4: 'Knock Knock',
    5: 'Oxygen',
    6: 'Extremis',
    7: 'The Pyramid at the End of the World',
    8: 'The Lie of the Land',
    9: 'Empress of Mars',
    10: 'The Eaters of Light',
    11: 'World Enough and Time',
    12: 'The Doctor Falls',
    13: 'Twice Upon A Time',
  },
  37: {
    1: 'The Woman Who Fell To Earth',
    2: 'The Ghost Monument',
    3: 'Rosa',
    4: 'Arachnids in the UK',
    5: 'The Tsuranga Conundrum',
    6: 'Demons of the Punjab',
    7: 'Kerblam!',
    8: 'The Witchfinders',
    9: 'It Takes You Away',
    10: 'The Battle of Ranskoor Av Kolos',
    11: 'Resolution',
  },
  38: {
    1: 'Spyfall, Part 1',
    2: 'Spyfall, Part 2',
    3: 'Orphan 55',
    4: "Nikola Tesla's Night of Terror",
    5: 'Fugitive of the Judoon',
    6: 'Praxeus',
    7: 'Can You Hear Me?',
    8: 'The Haunting of Villa Diodati',
    9: 'Ascension of the Cybermen',
    10: 'The Timeless Children',
    11: 'Revolution of the Daleks',
  },
  39: {
    1: 'Flux Chapter One: The Halloween Apocalypse',
    2: 'Flux Chapter Two: War of the Sontarans',
    3: 'Flux Chapter Three: Once, Upon Time',
    4: 'Flux Chapter Four: Village of the Angels',
    5: 'Flux Chapter Five: Survivors of the Flux',
    6: 'Flux Chapter Six: The Vanquishers',
    7: 'Eve of the Daleks',
  },
}
